export class HandbookBO {
    id: string="00000000-0000-0000-0000-000000000000";
    handbookName: string;
    fileString: string;
    filePath: string;
    fileName:string;
    type:string;
   
}

export class GetListBase {
    currentpageno: number = 1;
  pageitem: number = 10;
  OnboardStatusLid: any;
  searchText: string;
  orderColumn: string = "handbookName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "handbookName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
}

export class GetHandbookBO extends GetListBase {
    agencyId: string | null;
    viewtype:string;
}

export class functionpermission {
    handbookcreate: boolean = true
    handbookdelete: boolean = true
    handbookdownload: boolean = true
    handbookview: boolean = true
  }
  